import { z } from 'zod';

function hasErrorDetail(err: unknown): err is ErrorWithDetail {
  return errorWithDetailSchema.safeParse(err).success;
}

export function getErrorDetail<ERR>(err: ERR): ERR;
export function getErrorDetail<ERR>(err: ERR, fallback: string): string;
export function getErrorDetail<ERR>(err: ERR, fallback?: string): string | ERR {
  if (hasErrorDetail(err)) {
    return JSON.stringify(err.body.detail, null, 2);
  }

  return fallback ?? err;
}

const errorWithDetailSchema = z.object({
  body: z.object({
    detail: z.union([z.string(), z.array(z.any())]),
  }),
});
export type ErrorWithDetail = z.infer<typeof errorWithDetailSchema>;
